import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  rootPage: {
    height: "100%"
  },
  header: {
    padding: "0 24px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    color: "grey",
    [theme.breakpoints.down("xs")]: {
      padding: "0 16px",
      boxShadow: "unset",
      position: "static"
    }
  },
  leftHeaderSide: {
    display: "flex",
    alignItems: "center"
  },
  page: {
    padding: 24,
    [theme.breakpoints.down("md")]: {
      padding: 12
    },
    [theme.breakpoints.down("xs")]: {
      padding: 0
    }
  },
  noDataHolder: {
    color: theme.palette.text.hint,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    fontSize: 18
  },
  loader: {
    width: 25,
    justifyContent: "flex-start",
    padding: 0
  }
}));
